<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-toolbar flat class="toolbar" dense justify="center">
        <v-toolbar-title align="center">
          <strong> Academic Dashboard </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense justify="center">
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="org"
            :items="org_list"
            item-text="name"
            return-object
            label="Organization"
            outlined
            @click="clear()"
            @change="getAy()"
          ></v-autocomplete>
        </v-col>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="ay"
            :items="academic_year_list"
            item-text="ay"
            item-value="ay"
            label="Academic Year"
            @click="clear()"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="std"
            :items="standard_list"
            item-text="standard"
            item-value="standard"
            label="Standard"
            @click="clear()"
            outlined
            @change="getStandard()"
          ></v-autocomplete>
        </v-col>
        <v-col sm="2" v-if="ay && std != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="div"
            :items="dision_list"
            item-text="div_name"
            item-value="div_name"
            label="Division"
            @click="clear()"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="2" v-if="div">
          <v-btn
            rounded
            class="button mt-6"
            @click="getAllReport()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        v-if="org_data_list != '' && org.name == 'All'"
      >
        <!-- {{org_data_list}} -->
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Student Count Chart </strong>
          </v-toolbar-title>
        </v-toolbar>
        <center><chart v-if="display_data" :options="option"></chart></center>
        <v-data-table
          :headers="headers"
          dense
          :items="org_data_list"
          class="elevation-1 mytable"
        >
          <template v-slot:top>
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong> Organization Student Count </strong>
              </v-toolbar-title>
            </v-toolbar>
            <br />
          </template>
          <template v-slot:item.total_org_stud_count="{ item }">
            <v-btn
              class="btn-css btn"
              @click="getOrgAcademicsDashboardReport(item.org_id)"
              >{{ item.total_org_stud_count }}</v-btn
            >
          </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="dialog" fullscreen>
        <v-card>
          <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Organization Academic Dashboard</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="toolbar" @click="dialog = false">Cancel</v-btn>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12" v-if="org_data != ''">
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong> Genderwise Student Count </strong>
              </v-toolbar-title>
            </v-toolbar>
            <br />
            <!-- new code  -->
            <v-row dense>
              <v-col cols="12" sm="1" md="1">
                <span>
                  <v-icon
                    class="dot"
                    style="background-color: #c23531"
                    color="#c23531"
                    >mdi-radiobox-blank </v-icon
                  >Female</span
                >
              </v-col>

              <v-col cols="12" sm="1" md="1">
                <span>
                  <v-icon
                    class="dot"
                    style="background-color: #2f4554"
                    color="#2f4554"
                    >mdi-radiobox-blank </v-icon
                  >Male</span
                >
              </v-col>
            </v-row>
            <!-- new code end -->
            <center><chart auto-resize :options="option1"></chart></center>
            <v-simple-table
              dense
              class="elevation-1 mytable"
              fixed-header
              height="500px"
            >
              <thead>
                <tr class="">
                  <th class="">Sr. No.</th>
                  <th class="">Standard</th>
                  <th
                    class=""
                    colspan="3"
                    v-for="(header, index) in division_list"
                    :key="index"
                  >
                    <center>{{ header }}</center>
                  </th>
                </tr>
              </thead>
              <tbody style="overflow-y: scroll">
                <tr>
                  <th></th>
                  <th></th>
                  <th
                    v-for="(header, index) in division_list.length * 3"
                    :key="index"
                  >
                    <span v-if="header % 3 == 0"> Total </span>
                    <span v-else-if="header % 3 == 1"> Female </span>
                    <span v-else> Male </span>
                  </th>
                </tr>
                <tr v-for="(s, index) in org_data" :key="s.std_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ s.std_name }}</td>
                  <td v-for="(header, index) in s.div_count" :key="index">
                    {{ header }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <br />
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong> Quotawise Student Count </strong>
              </v-toolbar-title>
            </v-toolbar>
            <br />
            <!-- new code  -->
            <v-row dense>
              <v-col cols="12" sm="1" md="1">
                <span>
                  <v-icon
                    class="dot"
                    style="background-color: #c23531"
                    color="#c23531"
                    >mdi-radiobox-blank </v-icon
                  >RTE</span
                >
              </v-col>

              <v-col cols="12" sm="1" md="1">
                <span>
                  <v-icon
                    class="dot"
                    style="background-color: #2f4554"
                    color="#2f4554"
                    >mdi-radiobox-blank </v-icon
                  >General</span
                >
              </v-col>
            </v-row>
            <!-- new code end -->
            <center><chart auto-resize :options="option2"></chart></center>
            <v-simple-table
              dense
              class="elevation-1 mytable"
              fixed-header
              height="500px"
            >
              <thead>
                <tr class="">
                  <th class="">Sr. No.</th>
                  <th class="">Standard</th>
                  <th
                    class=""
                    colspan="3"
                    v-for="(header, index) in division_list"
                    :key="index"
                  >
                    <center>{{ header }}</center>
                  </th>
                </tr>
              </thead>
              <tbody style="overflow-y: scroll">
                <tr>
                  <th></th>
                  <th></th>
                  <th
                    v-for="(header, index) in division_list.length * 3"
                    :key="index"
                  >
                    <span v-if="header % 3 == 0"> Total </span>
                    <span v-else-if="header % 3 == 1"> RTE </span>
                    <span v-else> General </span>
                  </th>
                </tr>
                <tr v-for="(s, index) in org_data" :key="s.std_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ s.std_name }}</td>
                  <td v-for="(header, index) in s.quota_count" :key="index">
                    {{ header }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-row justify="center" dense>
            <v-btn class="button mt-3" @click="dialog = false">Cancel</v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      loader: false,
      overlay: false,
      color: "",
      snackbar: false,
      search: null,
      snackbar_msg: null,
      fees_structure_data: null,
      current_academic_year: null,
      stream: null,
      div: null,
      std: null,
      header: null,
      academic_year_list: null,
      standard_list: null,
      dision_list: null,
      org_list: null,
      display_data: false,
      org: "",
      ay: null,
      org_data_list: [],
      division_list: [],
      dialog: false,
      org_data: [],
      fetch_loader: false,
      headers: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Organization",
          align: "center",
          sortable: false,
          value: "org_name",
        },
        {
          text: "Student Count",
          align: "center",
          sortable: false,
          value: "total_org_stud_count",
        },
      ],
      option: {
        height: "200px",
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            magicType: {
              show: true,
              type: ["line", "bar", "stack"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
              },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: {
              show: true,
              title: "Save As Image",
            },
            dataView: {
              show: true,
              title: "Data View",
              readonly: false,
            },
          },
        },
        calculable: true,
        legend: {
          data: [],
          itemGap: 5,
        },
        grid: {
          top: "12%",
          left: "6%", // change from 1% by shiv
          right: "16%", // change from 10% by shiv
          bottom: " 3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 15,
            rotate: 45,
          },
          name: "School",
          nameLocation: "end",
          offset: 10,
        },
        yAxis: {
          type: "value",
          name: "Student Count",
          nameLocation: "end",
          offset: 10,
        },
        legend: {
          data: ["X-axis:Organization", "Y-axis:# Students"],
          show: true,
        },
        series: [
          {
            data: [],
            value: [],
            type: "bar",

            //name:'Direct'
          },
        ],
        // series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      },
      option1: {
        height: "200px",
        // width:"1500px",
        // color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            magicType: {
              show: true,
              type: ["line", "bar", "stack"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
              },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: {
              show: true,
              title: "Save As Image",
            },
            dataView: {
              show: true,
              title: "Data View",
              readonly: false,
            },
          },
        },
        calculable: true,
        legend: {
          data: [],
          itemGap: 5,
        },
        grid: {
          top: "12%",
          left: "6%", // change from 1% by shiv
          right: "16%", // change from 10% by shiv
          bottom: " 3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 15,
            rotate: 35,
          },
          axisTick: {
            alignWithLabel: true,
          },
          name: "Standard",
          nameLocation: "end",
          offset: 10,
        },
        yAxis: {
          type: "value",
          name: "Student Count",
          nameLocation: "end",
          offset: 10,
        },
        series: [
          {
            data: [],
            value: [],
            type: "bar",

            // label: {
            //     show: true,
            //     position: "top",
            //     rotate: 45,
            //     offset: [2, 5],
            // },
            //name:'Direct'
          },
          {
            data: [],
            value: [],
            type: "bar",

            // label: {
            //     show: true,
            //     rotate: 45,
            //     position: "top",
            //     offset: [2, 5],
            // },
            //name:'Direct'
          },
        ],
      },
      option2: {
        height: "200px",
        //width:"1500px",
        // color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            magicType: {
              show: true,
              type: ["line", "bar", "stack"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
              },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: {
              show: true,
              title: "Save As Image",
            },
            dataView: {
              show: true,
              title: "Data View",
              readonly: false,
            },
          },
        },
        calculable: true,
        legend: {
          data: [],
          itemGap: 5,
        },
        grid: {
          top: "12%",
          left: "6%", // change from 1% by shiv
          right: "16%", // change from 10% by shiv
          bottom: " 3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 15,
            rotate: 45,
          },
          name: "Standard",
          nameLocation: "end",
          offset: 10,
        },
        yAxis: {
          type: "value",
          name: "Quota Students",
          nameLocation: "end",
          offset: 10,
        },
        series: [
          {
            data: [],
            value: [],
            type: "bar",
            // label: {
            //     show: true,
            //     position: "top",
            //     rotate: 45,
            //     offset: [2, 5],
            // },
            //name:'Direct'
          },
          {
            data: [],
            value: [],
            type: "bar",
            // label: {
            //     show: true,
            //     rotate: 45,
            //     position: "top",
            //     offset: [2, 5],
            // },
            //name:'Direct'
          },
        ],
      },
    };
  },
  methods: {
    clear() {
      (this.org_data_list = []),
        (this.division_list = []),
        (this.org_data = []);
    },
    getAllReport() {
      if (this.org.name == "All") {
        this.fetch_loader = true;
        const data = {
          ay: this.ay,
          std: this.std,
          org: this.org.id,
          div: this.div,
        };
        axios
          .post("/Management/getAcademicsDashboardReport", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_data_list = res.data.org_data_list;
              this.option.series[0].data = res.data.value;
              this.option.xAxis.data = res.data.data;
              this.option.series[0].label = {
                normal: {
                  show: true,
                  position: "top",
                  formatter: (params) => {
                    let outof = this.option.series[0].value[params.dataIndex]; //this.series[0].data[params.dataIndex];;
                    return outof;
                  },
                },
              };
              this.display_data = true;
              this.fetch_loader = false;
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
              this.fetch_loader = false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.fetch_loader = false;
          })
          .finally(() => {
            //close loader
            this.fetch_loader = false;
          });
      } else {
        // alert("in else")
        this.getOrgAcademicsDashboardReport(this.org.id);
      }
    },
    getOrgAcademicsDashboardReport(org) {
      this.overlay = true;
      const data = {
        ay: this.ay,
        std: this.std,
        org: org,
        div: this.div,
      };
      axios
        .post("/Management/getOrgAcademicsDashboardReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_data = res.data.org_data;
            this.division_list = res.data.division_list;
            this.option1.series[0].data = res.data.fvalue;
            this.option1.series[1].data = res.data.mvalue;
            this.option1.xAxis.data = res.data.data;

            this.option2.series[0].data = res.data.rvalue;
            this.option2.series[1].data = res.data.gvalue;
            this.option2.xAxis.data = res.data.data;
            this.fetch_loader = false;
            this.dialog = true;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          //close loader
        });
    },
    getAy() {
      this.academic_year_list = null,
      this.standard_list = null,
      this.ay = null
      this.std = null
      const data = {
        org: this.org.id,
      };
      axios
        .post("/Management/getAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.academic_year_list;
            this.standard_list = res.data.standard_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
    getStandard() {
      const data = {
        ay: this.ay,
        std: this.std,
        org: this.org.id,
      };
      axios
        .post("/Management/getDiv", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.dision_list = res.data.dision_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/Management/getOrg")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_list = res.data.org_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: center;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: center;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}

/* shiv css */
.dot {
  height: 25px;
  width: 25px;
  /* background-color: #bbb; */
  border-radius: 50%;
  display: inline-block;
}
</style>
